/**
 * Constantes y configuraciones para el módulo TiposUsuario
 */

/**
 * Límites de validación para campos de formulario
 */
export const LIMITES_VALIDACION = {
    NOMBRE_MAX: 100,
    DESCRIPCION_MAX: 500,
} as const;

/**
 * Mensajes de error estandarizados
 */
export const MENSAJES_ERROR = {
    NOMBRE_REQUERIDO: 'El nombre es requerido',
    NOMBRE_EXCEDE_LIMITE: `El nombre no puede exceder ${LIMITES_VALIDACION.NOMBRE_MAX} caracteres`,
    DESCRIPCION_EXCEDE_LIMITE: `La descripción no puede exceder ${LIMITES_VALIDACION.DESCRIPCION_MAX} caracteres`,
    JSON_INVALIDO: 'El JSON de campos personalizados no es válido',

    // Errores genéricos
    ERROR_CARGAR: 'Error al cargar tipos de usuario',
    ERROR_CREAR: 'Error al crear tipo de usuario',
    ERROR_ACTUALIZAR: 'Error al actualizar tipo de usuario',
    ERROR_ELIMINAR: 'Error al eliminar tipo de usuario',

    // Mensajes de éxito
    CREADO_EXITOSO: 'Tipo de usuario creado exitosamente',
    ACTUALIZADO_EXITOSO: 'Tipo de usuario actualizado exitosamente',
    ELIMINADO_EXITOSO: 'Tipo de usuario eliminado exitosamente',
} as const;

/**
 * Textos de la interfaz de usuario
 */
export const TEXTOS_UI = {
    CONFIRMAR_ELIMINACION_TITULO: '¿Estás seguro de que deseas eliminar el tipo de usuario',
    ADVERTENCIA_PREFIJO: 'Atención:',
    ADVERTENCIA_USUARIOS: 'Este tipo de usuario tiene',
    ADVERTENCIA_SUFIJO: 'usuario(s) asociado(s).',
    NO_PUEDE_ELIMINAR: 'No se puede eliminar mientras tenga usuarios asociados.',
    NOTA_ELIMINACION: 'Esta acción no puede deshacerse.',
    BOTON_ELIMINANDO: 'Eliminando...',
    BOTON_ELIMINAR: 'Eliminar',
    CARGANDO_DATOS: 'Cargando datos...',
} as const;
